export const headerHtml = `
<section
	id="header_wrapper"
	data-sm="https://www.massbio.org/wp-content/uploads/2020/03/iStock-847276900-768x512.jpg"
	data-med="https://www.massbio.org/wp-content/uploads/2020/03/iStock-847276900-1200x800.jpg"
	data-lg="https://www.massbio.org/wp-content/uploads/2020/03/iStock-847276900-scaled.jpg"
	style="background-image: url('https://www.massbio.org/wp-content/uploads/2020/03/iStock-847276900-768x512.jpg');"
	class="header-wrapper swap">

	<header id="header" class="site-header" role="banner">
		<div class="container member-menu-wrapper">

			<div class="site-branding">
				<h1 class="site-title"><a href="https://www.massbio.org/" rel="home">MassBio</a></h1>
				<p class="site-description">Massachusetts Biotechnology Council</p>
				<button class="menu-toggle" aria-controls="primary-menu" aria-expanded="false"><span></span>Primary Menu</button>
			</div>

			<div class="header-member laptop">
				<div id="header_search" class="header-search laptop">
					<form role="search" method="get" class="search-form" action="/">
						<label>
							<span class="screen-reader-text">Search for:</span>
							<input type="search" class="search-field" value="" name="s" />
						</label>
						<button type="submit" class="search-submit">
							<span class="screen-reader-text">Search</span><i class="icon icon-search"></i>
						</button>
					</form>
				</div>

				<div class="social">
					<a class="open-search" href="#">
						<span class="screen-reader-text">Open search form</span>
						<i class="icon icon-search"></i>
					</a>
					<a href="https://www.twitter.com/MassBio" class="twitter" title="Follow us on Twitter">
						<i class="icon icon-twitter"></i>
					</a>
					<a href="https://www.linkedin.com/groups/65240/profile" class="linkedin" title="Connect with us on LinkedIn">
						<i class="icon icon-linkedin"></i>
					</a>
				</div>

				<nav id="member-navigation" class="member-navigation" role="navigation">
					<ul id="member_nav" class="member-menu">

						<li class="button-border menu-item">
							<a href="https://massbio.microsoftcrmportals.com/SignIn">
								Sign In/Create Account	</a>
						</li>
						<li class="button-border menu-item">
							<a href="https://www.massbio.org/pay-company-dues/">
								Pay Company Dues	</a>
						</li>
						<li class="button-border menu-item">
							<a href="https://massbio.microsoftcrmportals.com/company/membership-landing/">
								Become a Member	</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>

		<div class="container main-menu-wrapper">
			<div class="header-search mobile">

				<form role="search" method="get" class="search-form" action="/">
					<label>
						<span class="screen-reader-text">Search for:</span>
						<input type="search" class="search-field" value="" name="s" />
					</label>
					<button type="submit" class="search-submit">
						<span class="screen-reader-text">Search</span><i class="icon icon-search"></i>
					</button>
				</form>
			</div>
			<nav id="site-navigation" class="main-navigation" role="navigation"><ul id="main_nav" class="main-menu"><li id="menu-item-1991" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1991"><a href="https://www.massbio.org/resources/">Resources</a>
				<ul class="sub-menu">
					<li id="menu-item-206229" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-206229"><a href="https://www.massbio.org/industry-snapshot/">Industry Snapshot</a></li>
					<li id="menu-item-228388" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-228388"><a href="https://www.massbio.org/toolkit/">Biopharma Startup Toolkit</a></li>
					<li id="menu-item-17663" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17663"><a href="https://hub.massbio.org/">MassBio<em>Hub</em> – Conference Center</a></li>
					<li id="menu-item-22158" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-22158"><a href="https://www.massbio.org/covid-19-resource-center/">COVID-19 Resource Center</a></li>
					<li id="menu-item-17141" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17141"><a href="https://www.massbio.org/innovation-services/">Innovation Services</a></li>
					<li id="menu-item-17142" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17142"><a href="https://www.massbio.org/policy-advocacy/">Policy &#038; Advocacy</a></li>
					<li id="menu-item-17140" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17140"><a href="https://www.massbio.org/economic-development/">Economic Development</a></li>
					<li id="menu-item-17139" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17139"><a href="https://www.massbio.org/career-center/">Career Center</a></li>
				</ul>
			</li>
				<li id="menu-item-15477" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-15477"><a href="https://www.massbio.org/events/">Events</a>
					<ul class="sub-menu">
						<li id="menu-item-17831" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17831"><a href="https://www.massbio.org/events/">Events Calendar</a></li>
						<li id="menu-item-17836" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17836"><a href="https://www.massbio.org/overview-of-events/">Overview of Events</a></li>
						<li id="menu-item-114043" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-114043"><a href="https://www.massbio.org/get-involved-in-massbio-events/">Get Involved</a></li>
					</ul>
				</li>
				<li id="menu-item-181100" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-181100"><a href="https://www.massbio.org/membership/">Membership</a>
					<ul class="sub-menu">
						<li id="menu-item-17087" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17087"><a href="/members/">Member Directory</a></li>
						<li id="menu-item-17146" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17146"><a href="https://www.massbio.org/membership/benefits-of-membership/">Benefits of Membership</a></li>
						<li id="menu-item-184205" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-184205"><a href="https://www.massbio.org/membership/pricing/">Pricing</a></li>
						<li id="menu-item-17796" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17796"><a href="https://www.massbio.org/membership/virtual-member-benefits/">Virtual Member Benefits</a></li>
						<li id="menu-item-181101" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-181101"><a href="https://www.massbio.org/news/member-news/">Member News</a></li>
						<li id="menu-item-17145" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17145"><a href="https://www.massbio.org/become-a-member/">Become a Member</a></li>
						<li id="menu-item-17136" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17136"><a href="https://www.massbio.org/pay-company-dues/">Pay Company Dues</a></li>
					</ul>
				</li>
				<li id="menu-item-1994" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1994"><a href="https://www.massbio.org/massbio-edge/">MassBio<em>Edge</em></a>
					<ul class="sub-menu">
						<li id="menu-item-17826" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17826"><a href="https://www.massbio.org/massbio-edge/">MassBio<em>Edge</em></a></li>
						<li id="menu-item-17679" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17679"><a href="https://connector.massbio.org/preferred-partners">Preferred Partners</a></li>
						<li id="menu-item-17680" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17680"><a href="https://connector.massbio.org/employee-rewards">Employee Rewards</a></li>
						<li id="menu-item-17747" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17747"><a href="https://www.massbio.org/massbio-edge/edge-benefits/"><em>Edge</em> Benefits</a></li>
					</ul>
				</li>
				<li id="menu-item-1995" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1995"><a href="https://www.massbio.org/initiatives/">Initiatives</a>
					<ul class="sub-menu">
						<li id="menu-item-54749" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-54749"><a href="https://www.massbio.org/2025-report/">State of Possible 2025 Report</a></li>
						<li id="menu-item-1997" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1997"><a href="https://www.massbio.org/initiatives/equity-diversity-and-inclusion/">Diversity, Equity, and Inclusion</a></li>
						<li id="menu-item-61393" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-61393"><a href="https://www.massbio.org/initiatives/equity-diversity-and-inclusion/open-letter/">Open Letter 2.0 &#8211; CEO Pledge for ED&#038;I</a></li>
						<li id="menu-item-1998" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1998"><a href="https://www.massbio.org/initiatives/value-of-health/">Value of Health</a></li>
						<li id="menu-item-1996" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1996"><a href="https://www.massbio.org/initiatives/digital-health/">Digital Health</a></li>
						<li id="menu-item-2000" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2000"><a href="https://www.massbio.org/initiatives/bioready-communities/">BioReady Communities</a></li>
					</ul>
				</li>
				<li id="menu-item-2003" class="no-click menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-1964 current_page_item current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children menu-item-2003"><a href="https://www.massbio.org/about/" aria-current="page">About Us</a>
					<ul class="sub-menu">
						<li id="menu-item-17827" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-1964 current_page_item menu-item-17827"><a href="https://www.massbio.org/about/" aria-current="page">About Us</a></li>
						<li id="menu-item-17692" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17692"><a href="https://www.massbio.org/about/sponsorship-opportunities/">Sponsorship Opportunities</a></li>
						<li id="menu-item-16828" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-16828"><a href="https://www.massbio.org/about/staff-directory/">Staff</a></li>
						<li id="menu-item-16829" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-16829"><a href="https://www.massbio.org/about/board-of-directors/">Board of Directors</a></li>
						<li id="menu-item-17147" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17147"><a href="https://www.massbio.org/about/massbio-ed/">MassBioEd</a></li>
						<li id="menu-item-17150" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17150"><a href="https://www.massbio.org/about/faqs/">FAQs</a></li>
						<li id="menu-item-17148" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-17148"><a href="https://www.massbio.org/contact/">Contact Us</a></li>
					</ul>
				</li>
				<li id="menu-item-2004" class="no-click menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-2004"><a href="https://www.massbio.org/news/">News</a>
					<ul class="sub-menu">
						<li id="menu-item-17834" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-17834"><a href="https://www.massbio.org/news/">News &#038; Thought Leadership</a></li>
						<li id="menu-item-84268" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-84268"><a href="https://www.massbio.org/news/state-of-possible-podcast/">State of Possible Podcast</a></li>
					</ul>
				</li>
			</ul>					<div class="header-member mobile">

				<nav id="member-navigation" class="member-navigation" role="navigation">
					<ul id="member_nav" class="member-menu">

						<li class="button-border menu-item">
							<a href="https://massbio.microsoftcrmportals.com/SignIn">
								Sign In/Create Account	</a>
						</li>
						<li class="button-border menu-item">
							<a href="https://www.massbio.org/pay-company-dues/">
								Pay Company Dues	</a>
						</li>
						<li class="button-border menu-item">
							<a href="https://massbio.microsoftcrmportals.com/company/membership-landing/">
								Become a Member	</a>
						</li>
					</ul>
				</nav>

				<div class="social">
					<a class="open-search" href="#">
						<span class="screen-reader-text">Open search form</span>
						<i class="icon icon-search"></i>
					</a>
					<a href="https://www.twitter.com/MassBio" class="twitter" title="Follow us on Twitter">
						<i class="icon icon-twitter"></i>
					</a>
					<a href="https://www.linkedin.com/groups/65240/profile" class="linkedin" title="Connect with us on LinkedIn">
						<i class="icon icon-linkedin"></i>
					</a>
				</div>
			</div>
			</nav>			</div>
	</header>


	<header class="page-header">
		<div class="container">
			<h1>MassBio Events</h1>
		</div>
	</header>

	<a class="laptop menu-opener" href="#">
		<span class="screen-reader-text">Click to Open Main Menu</span>
	</a>

</section>
`

export default headerHtml;
